import React from 'react';
import { ChevronRight } from 'lucide-react';
import { colors } from '../../../theme';
import { SS } from './settingsStyles';

/**
 * A row that opens something.
 *
 * The whole row is the target — 56px tall, one button, no nested controls.
 * `value` is the current answer shown on the right, so a person can read the
 * state of the app without opening seven screens.
 */
/**
 * `dot` is a colour, and it is the smallest thing this screen can say.
 *
 * It replaced a paragraph: «архив не создавался» was a banner at the top of
 * settings, three lines tall, above rows that mattered more, for a state that
 * is already written on the archive row itself. A dot next to the title says
 * the same thing where the answer already is, and costs nothing to ignore.
 */
export default function NavRow({ icon: Icon, title, value, badge, hint, dot, onPress, last = false }) {
  return (
    <button
      onClick={onPress}
      style={{
        ...SS.navRow,
        borderBottom: last ? 'none' : `1px solid ${colors.gray100}`,
        flexWrap: hint ? 'wrap' : 'nowrap',
      }}
    >
      {Icon && <Icon size={20} color={colors.gray400} style={{ flexShrink: 0 }} />}
      <span style={SS.navRowTitle}>{title}</span>
      {dot ? <span aria-hidden="true" style={{
        width: 7, height: 7, borderRadius: 4, background: dot, flexShrink: 0, marginLeft: -4,
      }} /> : null}
      {badge ? <span style={SS.navRowBadge}>{badge}</span> : null}
      {value && !badge ? <span style={SS.navRowValue}>{value}</span> : null}
      <ChevronRight size={18} color={colors.gray400} style={{ marginLeft: badge || value ? 8 : 'auto', flexShrink: 0 }} />
      {hint && <div style={{ ...SS.consequence, flexBasis: '100%', marginTop: 2 }}>{hint}</div>}
    </button>
  );
}
